
<div class="h100 flex-cont">
  <div class="inner-cont">
    <awc-logo [appName]="appName"></awc-logo>

    @if (conceptService.loading()) {
      <span>Loading Concept...</span>
      <awc-icon [icon]="Icons.SPINNER"></awc-icon>
    } @else if (conceptService.loadingErrorMessage()) {
      <span>Oops! Something went wrong. If the issue persists, please contact support.</span>
      <div class="error-message-cont">
        <awc-icon [icon]="Icons.LEFT_ARROW"></awc-icon>
        <div><span>{{ conceptService.loadingErrorMessage() }}</span></div>
        <awc-icon [icon]="Icons.RIGHT_ARROW"></awc-icon>
      </div>
    }
  </div>
</div>
